// Make sure global namespace exists
window.ShopifyTheme = window.ShopifyTheme || {};

// Define public function
window.ShopifyTheme.updateVariantPrice = function(variantchanged) {
  //check conditions to differ the card variant picker with PDP variant picker
  if (variantchanged.closest('.product-card__content')) {
    const picker = variantchanged.closest('variant-picker');
    if (!picker) {
      console.warn('No variant picker found');
      return;
    }

    let variantid = variantchanged.value;
    let price = variantchanged.options[variantchanged.selectedIndex].getAttribute('data-option-value-price');

    // Update container attribute with variant ID
    const productCard = variantchanged.closest('.product-card__content');
    const priceContainer = productCard.querySelector('product-price [ref="priceContainer"] .price');
    if (priceContainer) priceContainer.innerHTML = `$${price}`;

    const formComponent = productCard.querySelector('product-form-component');
    if (formComponent) {
      formComponent.setAttribute('data-variant-id', variantid);
      const input = formComponent.querySelector('input[name="id"]');
      if (input) input.value = variantid;
    }

  } else if (variantchanged.closest('.product-information')) {
    if (variantchanged.getAttribute('data-variant-type') === 'color') {
      //directly selected the variant from dropdown
      variantchanged.closest('.variant-option').querySelectorAll('.variant-option__button-label--selected').forEach((el) => {
        el.classList.remove('variant-option__button-label--selected');
      });
      variantchanged.closest('.variant-option__button-label').classList.add('variant-option__button-label--selected');
      variantchanged.closest('.variant-option').querySelector('.variant-option__swatch-value').textContent = variantchanged.value;
    }

    // Find the closest variant-picker
    const picker = variantchanged.closest('variant-picker');
    if (!picker) {
      console.warn('No variant picker found');
      return;
    }

    // Collect selected options
    const selectedOptions = [];
    picker.querySelectorAll('.variant-option__button-label:has(:checked)').forEach((el) => {
      selectedOptions.push(el.querySelector('input').value);
    });

    const productvars = JSON.parse(picker.dataset.productVariants || '[]');

    // Find matching variant
    const matchedVariant = productvars.find(variant => {
      if (selectedOptions.length === 1) return variant.option1 === selectedOptions[0];
      if (selectedOptions.length === 2) return variant.option1 === selectedOptions[0] && variant.option2 === selectedOptions[1];
      if (selectedOptions.length === 3) return variant.option1 === selectedOptions[0] && variant.option2 === selectedOptions[1] && variant.option3 === selectedOptions[2];
      return false;
    });

    if (!matchedVariant) return;

    // Update price
    let container = picker.closest('.product-card__content') || picker.closest('.product-information');
    if (!container) return;

    const priceContainers = container.querySelectorAll('[ref="priceContainer"]');
    priceContainers.forEach((el) => {
      el.innerHTML = `<span class="price text-neutral-faded">$${(matchedVariant.price / 100).toFixed(2)}</span>`;
    });

    // Update container attribute with variant ID
    window.history.replaceState({}, '', `${window.location.pathname}?variant=${matchedVariant.id}`);

    // Update product form component if exists
    const productForm = container.querySelector('product-form-component');
    if (productForm) {
      productForm.setAttribute('data-variant-id', matchedVariant.id);
      const input = productForm.querySelector('input[name="id"]');
      if (input) input.value = matchedVariant.id;
    }

    // Update the SKU if exists
    const skuElement = document.getElementById('part-number');
    if (skuElement) {
      skuElement.textContent = `Part Number - ${matchedVariant.sku}`;
    }

    // Update the Minimal container if exists
    const minimalContainer = document.querySelector('.minimal-summary.container');
    if (minimalContainer) {
      minimalContainer.querySelector('.minimal-summary__content .part-number').textContent = `Part Number - ${matchedVariant.sku}`;
      minimalContainer.querySelectorAll('.minimal-summary__variants .product-option-value').forEach((el, index) => {
        el.textContent = selectedOptions[index] || '';
      });
      minimalContainer.querySelector('.minimal-summary__price .price').textContent = `$${(matchedVariant.price / 100).toFixed(2)}`;

      const miniForm = minimalContainer.querySelector('.minimal-summary_buy-buttons product-form-component');
      if (miniForm) {
        miniForm.setAttribute('data-variant-id', matchedVariant.id);
        const miniInput = miniForm.querySelector('input[name="id"]');
        if (miniInput) miniInput.value = matchedVariant.id;
      }
    }

    // Update tier prices: savings table, qty pills and promo banner
    document.querySelectorAll('.quantity-discount').forEach((el) => {
      el.dataset.price = matchedVariant.price;
    });
    document.querySelectorAll(
      '.saving-table__price[data-discount], .quantity-discount__value[data-discount], .promo-banner__next-price[data-discount]',
    ).forEach((el) => {
      const discount = Number(el.dataset.discount);
      el.textContent = `$${(matchedVariant.price * (1 - discount / 100) / 100).toFixed(2)}`;
    });
  } else {
    console.log('Variant changed outside known containers');
  }
};

// Create a public alias for inline calls
window.updateVariantPrice = window.ShopifyTheme.updateVariantPrice;
